// Stream through the canonical player. Copying a track into a fade deck and then back into
// this element started a second range download of the same long ambience file.
export function ambienceSceneInteractive(): boolean {
  if (document.readyState !== 'complete') return false;
  const frame = document.querySelector<HTMLIFrameElement>('[data-ft3d-encounter-frame]');
  try {
    const sceneWindow = (frame ? frame.contentWindow : window) as (Window & {
      __ftZoneGenerationPreview?: { sceneReady?: boolean };
    }) | null;
    const sceneDocument = sceneWindow?.document;
    const overlay = sceneDocument?.querySelector('[data-ft-zone-loading]');
    if (!frame && !overlay) return true;
    return sceneWindow?.__ftZoneGenerationPreview?.sceneReady === true
      && sceneDocument?.readyState === 'complete'
      && !overlay?.classList.contains('is-active');
  } catch { return false; }
}

export class AmbiencePlayback {
  private version = 0;
  private wanted: string | null = null;
  private files = new Map<string, string>();

  async sync(id: string, resolve: (id: string) => Promise<string>): Promise<void> {
    const main = document.getElementById('audio_player_ambience_1') as HTMLAudioElement | null;
    if (!main || this.wanted === id) return;
    this.wanted = id;
    const version = ++this.version;
    try {
      let file = id ? this.files.get(id) : '';
      if (id && !file) { file = await resolve(id); if (file) this.files.set(id, file); }
      if (version !== this.version) return;
      if (id && !file) throw new Error('Ambience track unavailable');
      main.preload = 'none';
      main.onloadeddata = null;
      main.oncanplaythrough = null;
      main.loop = true;
      main.dataset.currentAudioId = id;
      if (!file) {
        main.pause();
        main.removeAttribute('src');
        main.load();
        return;
      }
      // A blocked autoplay retries play() on the same buffered source; setting src or calling
      // load() again would abort and restart its range request. Volume/mute remain user-owned.
      if (main.getAttribute('src') !== file) main.src = file;
      await main.play();
    } catch (error) {
      if (version === this.version) this.wanted = null;
      if (!(error instanceof DOMException && error.name === 'NotAllowedError')) console.warn('[room ambience]', error);
    }
  }
}
